import React from "react";

import Box from "@mui/material/Box";

import Toolbar from "@mui/material/Toolbar";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import AppBar from "@mui/material/AppBar";

import { makeStyles } from "tss-react/mui";

import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import KMKDialog from "./KMKDialog";

const useStyles = makeStyles()((theme) => ({
  dialogPaper: {
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
    },
    "& .MuiGrid-item": {
      paddingTop: "15px",
    },
    "& .MuiGrid-item .MuiTextField-root": {
      marginTop: 0,
    },
    "& .MuiDivider-root": {
      marginTop: "5px",
      marginBottom: "9px",
    },
    "& .MuiDialogActions-root": {
      padding: "0 20px 10px 0",
    },
  },
  formContainer: {
    display: "grid",
    width: "100%",
    textAlign: "left",
    minHeight: "110px",
    maxHeight: "400px",
    overflow: "auto",
  },
  Toolbar: {
    fontSize: "1.1rem",
    backgroundColor: "white",
    color: "black",
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  container: {
    padding: 0,
    backgroundColor: "#FFFFFF",
  },
}));

function NotAllowedDialog({ notAllowedDialog, onClose }) {
  const { classes } = useStyles();

  return (
    <KMKDialog className={classes.dialogPaper} open={true} maxWidth="md" onClose={onClose}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar className={classes.Toolbar}>
          <ReportProblemIcon color="warning" />
          {notAllowedDialog.title}
        </Toolbar>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </AppBar>
      <Box
        sx={{
          width: "100%",
        }}
        className={classes.container}
      >
        <Box component="form" className={classes.formContainer}>
          <DialogContent style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            {notAllowedDialog.confirmMessage}
          </DialogContent>
        </Box>
      </Box>
    </KMKDialog>
  );
}

export default React.memo(NotAllowedDialog);
